/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cascade_Dialog_Forcing_HelpInputs */



/**
* | output |
* | --- |
* | "Production systems with priority 1 will always start first. If backup is needed, other systems will take over according to their priority" |
*
* @param {Cascade_Dialog_Forcing_HelpInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const cascade_dialog_forcing_help = /** @type {((inputs?: Cascade_Dialog_Forcing_HelpInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cascade_Dialog_Forcing_HelpInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Production systems with priority 1 will always start first. If backup is needed, other systems will take over according to their priority")
	return /** @type {LocalizedString} */ ("Les systèmes de production avec la priorité 1 seront toujours les premiers à démarrer. En cas de besoin d’appoint, les autres systèmes prendront le relais selon leur priorité")
});